import { render, staticRenderFns } from "./JobStatusRelationDetailList.vue?vue&type=template&id=cc3514fc&"
import script from "./JobStatusRelationDetailList.vue?vue&type=script&lang=js&"
export * from "./JobStatusRelationDetailList.vue?vue&type=script&lang=js&"
import style0 from "./JobStatusRelationDetailList.vue?vue&type=style&index=0&id=cc3514fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports